import axiosInstance from "../../../../../api/AxiosInstance";
import { endpoints } from "../../../../../services/endpoints";
import { getFilterCategoryRequest, getFilterCategoryRequestError, getFilterCategoryRequestSuccess } from "../../../../slices/User/Detail/Filters/GetCategorySlice";

export const GetSupplierCategoriesApi = () => async (dispatch) => {
    try {
        dispatch(getFilterCategoryRequest());
        axiosInstance({
            method: "GET",
            url: endpoints.getSuppliersFilterCategories,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getFilterCategoryRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getFilterCategoryRequestError(_error));
            });
    } catch (error) {
    }
};
